var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 381.11999 381.11998",
    width: 381.12,
    height: 381.12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 516.23999,
    y1: 132.59,
    x2: 325.64999,
    y2: 462.69,
    gradientTransform: "rotate(45,244.45886,-224.54931)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a094",
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015670",
    id: "stop6"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: -5.6946749e-7,
    cy: 269.49252,
    r: 190.56,
    transform: "rotate(-45)",
    id: "circle11",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 126.30719,183.27626 c 48.21,-44.37 81.78,-95.000005 82.13,-95.570005 l 7.51,-11.41 2.77,13.37 c 7.95,38.290005 35.36,141.830005 66.31,161.000005 a 5.6773585,5.6773585 0 0 1 -6,9.64 c -17.68,-11 -35.1,-42.84 -51.76,-94.7 -7.78,-24.2 -13.6,-47.35 -16.82,-61 -12.19,16.89 -39.37,49.76 -72.34,83 a 42.42,42.42 0 0 0 -6.46,8.22 c -9.18,15.56 1.31,22.28 6,25.11 16.62,9.93 60.23,-14.66 73.1,-21.73 l 14.74,-8.07 -6.83,15.35 c -0.9,2 -22.68,50.2 -60.85,69 a 44,44 0 0 1 -19.54,4.55 46,46 0 0 1 -37.87,-20.12 c -10.939995,-16.38 -11.869995,-43.33 18.35,-69.84 2.53,-2.22 5.1,-4.53 7.56,-6.8",
    id: "path13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.168997a9b4219b180c4b9bdbe3f827ba.svg";
export { ForwardRef as ReactComponent };